import { MutationTree } from "vuex";
import { ITaskState, ITimelineItem } from "./types";

export namespace TASK_MUTATIONS {
  export const TOGGLE_IS_LOADING = "toggleLoading";
  export const SET_APPLICATION_TIMELINE = "setApplicationTimeline";
  export const UPDATE_TASK = "updateTask";
}

export const mutations: MutationTree<ITaskState> = {
  [TASK_MUTATIONS.TOGGLE_IS_LOADING](
    state: ITaskState,
    isLoading: boolean
  ): void {
    state.isLoading = isLoading;
  },
  [TASK_MUTATIONS.UPDATE_TASK](state: ITaskState, task: ITimelineItem): void {
    // Find the index of the task to replace
    const taskIndex = state.applicationTimeline.findIndex(
      item => item.taskId === task.taskId
    );
    // If found, use splice to ensure reactivity works
    if (taskIndex >= 0) {
      state.applicationTimeline.splice(taskIndex, 1, task);
    }
  },
  [TASK_MUTATIONS.SET_APPLICATION_TIMELINE](
    state: ITaskState,
    timeline: ITimelineItem[]
  ): void {
    state.applicationTimeline = timeline;
  }
};
